export default "__VITE_ASSET__fbb431ba__"